import React, { useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import DepartmentGoalDetail from './DepartmentGoalDetail';
import EmployeeGoalDetail from './EmployeeGoalDetail';
import SupplierGoalDetail from './SupplierGoalDetail';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// Add this CSS (you can put it in your global CSS file or as a style tag)
const tableStyles = {
  tableLayout: 'fixed',
  width: '100%'
};

const columnStyles = {
  beginDate: {
    width: '150px' // Adjust this value as needed
  },
  endDate: {
    width: '150px' // Adjust this value as needed
  }
};

const GoalsDetailPage = () => {
    const [rowData, setRowData] = useState([]);
    const [stateId, setStateId] = useState(null)
    const navigate = useNavigate();
    const { state } = useLocation();
    const { data, isLoading } = useFetch(`templates/data/${stateId}`);

    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            setRowData(data);
        }
    }, [data]);

    useEffect(() => {
        if (state !== null && state.id === "") {
            setStateId(null);
        } else if (state && state.id !== "") {
            const id = state.id;
            setStateId(id);
        }
    }, [state, stateId]);

    const handleClick = (rowData) => {
        const route = `/assigngoal`;
        navigate(route, { state: rowData });
    };

    if (isLoading) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2 py-2">
                        <i className="fa-solid fa-spinner fa-spin"></i>
                    </h1>
                </div>
            </main>
        );
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">
                        <Link to="/goal">
                            <i className="fa-solid fa-arrow-left"></i>
                        </Link>
                        {rowData.goal && rowData.goal.goal_name}
                    </h1>
                    <button className="btn-orange" onClick={() => handleClick(rowData)}>
                        Assign&nbsp;Goal
                    </button>
                </div>

                {rowData.goal ? (
                    <ul className="goaldetails">
                        {Object.entries(rowData.goal).map(([key, value]) => (
                            <li key={key}>
                                <span>{key.replace(/_/g, " ")}</span> <span>{value}</span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <span>There is no data</span>
                )}

                <div>
                    <h4 className='tabletitle'>Departments</h4>
                    <table className="table goal-details" style={tableStyles}>
                        <thead>
                            <tr>
                                <th>Department Name</th>
                                <th style={columnStyles.beginDate}>Begin Date</th>
                                <th style={columnStyles.endDate}>End Date</th>
                                <th>Weightage%</th>
                                <th>Target Achieved</th>
                            </tr>
                        </thead>
                        <tbody>
                            <DepartmentGoalDetail rowDataDepartment={rowData.department} />
                        </tbody>
                    </table>
                </div>
                <div>
                    <h4 className='tabletitle'>Employees</h4>
                    <table className="table goal-details" style={tableStyles}>
                        <thead>
                            <tr>
                                <th>Employee Name</th>
                                <th style={columnStyles.beginDate}>Begin Date</th>
                                <th style={columnStyles.endDate}>End Date</th>
                                <th>Assigned by</th>
                                <th>Weightage%</th>
                                <th>Target Achieved</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <EmployeeGoalDetail rowDataEmployee={rowData.employees} />
                        </tbody>
                    </table>
                </div>
                <div>
                    <h4 className='tabletitle'> Suppliers</h4>
                    <table className="table goal-details" style={tableStyles}>
                        <thead>
                            <tr>
                                <th>Supplier Name</th>
                                <th style={columnStyles.beginDate}>Begin Date</th>
                                <th style={columnStyles.endDate}>End Date</th>
                                <th>Assigned by</th>
                                <th>Weightage%</th>
                                <th>Target Achieved</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <SupplierGoalDetail rowDataSupplier={rowData.supplier} />
                        </tbody>
                    </table>
                </div>
            </main>
        </>
    );
};

export default GoalsDetailPage;